import styles from './form-label.module.scss';
import MaterialFormLabel from '@mui/material/FormLabel';

/* eslint-disable-next-line */
export interface FormLabelProps {
  children?: any,
  // classes?: object,
  // color?: 'error'| 'info'| 'primary'| 'secondary'| 'success'| 'warning',
  component?: any,
  // disabled?: boolean,
  // error?: boolean,
  // filled?: boolean,
  // focused?: boolean,
  // required?: boolean,
  sx?: any,
  // className?: string
}

export function FormLabel(props: FormLabelProps) {
  return (
    <MaterialFormLabel
      component={props.component}
      sx={props.sx}>
      {props.children}
    </MaterialFormLabel>
  );
}

export default FormLabel;
